import React from 'react';
import Discipline from '../../components/discipline';

export default function Responsibility() {
  return <Discipline locale="da" id="responsibility" />;
}
